import React from 'react';
import PropTypes from 'prop-types';
import FormInputContainer from './containers/FormInputContainer';
import TextInput from './TextInput';

const Input = ({ input, required, label, meta, isPassword, ...props }) => (
  <FormInputContainer
    label={label}
    required={required}
    meta={meta}
    dataDesc={`${meta.form}__${input.name}`}
    isPassword={isPassword}
  >
    <TextInput {...props} {...input} formName={meta.form} isPassword={isPassword} />
  </FormInputContainer>
);

Input.defaultProps = {
  label: null,
  placeholder: '',
  required: false,
  meta: null,
  isPassword: false
};

Input.propTypes = {
  label: PropTypes.any,
  placeholder: PropTypes.any,
  type: PropTypes.string.isRequired,
  required: PropTypes.bool,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onDragStart: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    form: PropTypes.any
  }),
  isPassword: PropTypes.bool
};

export default Input;
